import React, { useState, useEffect } from 'react';
import { experimentalStyled, useMediaQuery, Container, Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Sidebar from './sidebar/Sidebar';
import Header from './header/Header';
import Footer from './footer/Footer';
import Customizer from './customizer/Customizer';
import { TopbarHeight } from '../../assets/global/Theme-variable';
import { getMyPermission } from '../../redux/slices/user-access.slice';
import { checkConfig, configure, loadLoggedUser } from '../../redux/slices/auth.slice';
import { useDispatch, useSelector } from "react-redux";
import UnauthorizedModal from '../../components/modal/UnauthorizedModal';
import { setPermissionModal, setSwitchMg, setSwitchMgAllowed } from '../../redux/slices/ui.slice';
import { set } from 'lodash';
import { IsPermessionGranted, IsUserPermessionGranted } from './sidebar/Menuitems';
import { getPublicListMagasin } from '../../redux/slices/magasin.slice';
import Storage from '../../services/Storage';
import SidebarFB from './sidebar/SidebarFB';


const MainWrapper = experimentalStyled('div')(() => ({
  display: 'flex',
  minHeight: '100vh',
  overflow: 'hidden',
  width: '100%',
}));
const PageWrapper = experimentalStyled('div')(({ theme }) => ({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',

  backgroundColor: theme.palette.background.default,
  [theme.breakpoints.up('lg')]: {
    paddingTop: TopbarHeight,
  },
  [theme.breakpoints.down('lg')]: {
    paddingTop: '64px',
  },
}));

const FullLayoutFB = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [isMobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const customizer = useSelector((state) => state.ui_store);
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  
  const { loading, error, loggedUser } = useSelector(state => state.auth_store);

  const dispatch = useDispatch()
  

  useEffect(() => {
    dispatch(loadLoggedUser())
  }, [])


  return (
    <MainWrapper className={customizer?.activeMode === 'dark' ? 'darkbg' : ''}>
      <Header
        sx={{
          paddingLeft: isSidebarOpen && lgUp ? '265px' : '',
          backgroundColor: customizer?.activeMode === 'dark' ? '#20232a' : '#fafbfb',
        }}
        toggleSidebar={() => setSidebarOpen(!isSidebarOpen)}
        toggleMobileSidebar={() => setMobileSidebarOpen(true)}
        loggedUser={loggedUser}
      />

      <SidebarFB
        loggedUser={loggedUser}
        isSidebardir={customizer?.activeDir === 'ltr' ? 'left' : 'right'}
        isSidebarOpen={isSidebarOpen}
        isMobileSidebarOpen={isMobileSidebarOpen}
        onSidebarClose={() => setMobileSidebarOpen(false)}
      />

      <PageWrapper>
        <Container
          maxWidth={false}
          sx={{
            paddingTop: '20px',
            paddingLeft: isSidebarOpen && lgUp ? '280px!important' : '',
          }}
        >
          <Box sx={{ minHeight: 'calc(100vh - 170px)' }}>
            <Outlet />
          </Box>
          <Customizer />
          <Footer />
        </Container>
      </PageWrapper>
    </MainWrapper>
  );
};

export default FullLayoutFB;
